import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { ModalContext } from '../../../components/Modal/ModalContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useMakeActive = () => {
  const modalContext = useContext(ModalContext);
  const request = useHttps();
  const [loading, setLoading] = useState(false);

  const onMakeActiveError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while activating vehicle.',
    );
  };

  const onMakeActiveSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    toast.success('Vehicle activated successfully.');
    modalContext?.setShowModal(false);
  };

  const makeActive = async (data: any) => {
    const url: HttpConfig = {
      url: `api/v1/fleets/${data.id}/toggle-status`,
      method: 'post',
      data: data,
    };
    await request(url, onMakeActiveSuccess, setLoading, onMakeActiveError);
  };

  return { makeActive, loading };
};

export default useMakeActive;
